import { Button, Col, Divider, List, Modal, Row, Typography } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import HRadioButton from "../../components/custom/input/radio/HRadioButton";
import { useLocation, useNavigate } from "react-router-dom";
import InfoModal from "../../components/custom/modal/info/InfoModal";
import { ProviderCommonObj, ProviderExtendedCommonObj } from "../../constants/ProviderConstants";
import { AppContext } from "../../context/AppContext";
import AuthorizePage from "../OnboardingComponents/AuthorizePage";
import OnboardingFinishModalContent from "../OnboardingComponents/OnboardingFinishModalContent";
import { getAddTemplateUrl } from "../utils/commonUtils";
import { CommonLoadingV2, EmptyListView, TenDLCStatus } from "../utils/CommonVessels";
import Step2 from "./Step2";
import { useVoiceContext } from "../../voice/context/VoiceContext";
import VoiceOnboardingFinishPopup from "../../voice/onboarding/VoiceOnboardingFinishPopup";
import ChannelsPageServiceTitle from "../../pages/services/ChannelsPageServiceTitle";
import ServiceNotAuthorizedPanel from "./ServiceNotAuthorizedPanel";
import useHttp from "../../hooks/useHttp";
import ImportChat from "../utils/ImportChat";
import "../../assets/css/services/textsms.css";
import HButton from "../../components/custom/input/button/Button";
import { getCurrentFeature } from "../../voice/utils/VoiceUtils";
import { HELLOSEND_CALL_APP_INSTALLATION_URL, HELLOSEND_MESSAGE_APP_INSTALLATION_URL } from "../../constants/AppConstants";

function TextSMSAuthPage() {
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [rightServiceObj, setRightServiceObj] = useState({});
  const [showGotoLeftService, setShowGotoLeftService] = useState(false);
  const [showFinishButton, setShowFinishButton] = useState(false);
  const [buyNumberLoading] = useState(false);
  const [successAuthModal, setSuccessAuthModal] = useState(false);
  const location = useLocation();
  const rightServiceName = useMemo(() => {
    const pathName = location.pathname.split("/").pop();
    return pathName === "personal_whatsapp" ? "unipile_whatsapp" : pathName;
  }, [location.pathname]);

  const [campaignStatus, setCampaignStatus] = useState(null);
  const [brandStatus, setBrandStatus] = useState(null);
  const [callProperties] = useVoiceContext();
  const [showImportWhatsAppModal, setShowImportWhatsAppModal] = useState(false);

  const navigate = useNavigate();

  const { fetchData } = useHttp();

  let urlParams = new URLSearchParams(window.location.search);
  let onBoardingPage = urlParams.get("onBoardingPage");
  let sideBar = urlParams.get("sideBar");

  const [creditsAccessibleForMobile, setCreditsAccessibleForMobile] = useState(false);

  useEffect(() => {
    const controller = appProperties?.controller;
    if (!controller?.isCreditAccessible) return;

    controller
      .isCreditAccessible()
      .then((creditsAvailable) => {
        setCreditsAccessibleForMobile(creditsAvailable);
      })
      .catch((error) => {
        console.error("Error fetching credit accessibility:", error);
        setCreditsAccessibleForMobile(false);
      });
  }, [appProperties?.controller]);

  useEffect(() => {
    if (appProperties.osyncId) {
      let assignerObj1 = Object.assign({}, ProviderCommonObj, ProviderExtendedCommonObj[rightServiceName]);

      setAppProperties({
        ...appProperties,
        providerCommonObj: assignerObj1,
        rightServiceName: rightServiceName,
        app: ProviderExtendedCommonObj[rightServiceName]?.app,
      });
    }
  }, [appProperties.osyncId, rightServiceName]);

  useEffect(() => {
    let queryObj = appProperties?.installedApps?.find((app) => app?.right?.service_name === rightServiceName);
    if (appProperties.apps) {
      if (queryObj) {
        queryObj = {
          integId: queryObj?.integProps?.integId,
          serviceId: queryObj?.right?.service_id,
          isTrialAccount: queryObj?.right?.isTrialAccount,
          rightServiceName: queryObj?.right?.service_name,
          displayName: queryObj?.right?.service_display_name,
          authorized: queryObj?.right?.auth?.authorized,
          service_display_name: queryObj?.right?.service_display_name,
          serviceType: queryObj?.right?.serviceType,
        };
      }
      let queryObj2 =
        appProperties?.apps?.SMS?.find((app) => app.name === rightServiceName) ||
        appProperties?.apps?.MESSENGER?.find((app) => app.name === rightServiceName) ||
        appProperties?.apps?.WHATSAPP?.find((app) => app.name === rightServiceName) ||
        appProperties?.apps?.VOICE?.find((app) => app.name === rightServiceName);

      if (queryObj2) {
        queryObj2 = {
          integId: queryObj2?.integId,
          serviceId: queryObj2?.serviceId,
          isTrialAccount: queryObj2?.isTrialAccount,
          rightServiceName: queryObj2?.name,
          displayName: queryObj2?.displayName,
          authorized: queryObj2?.authorized,
          service_display_name: queryObj2?.displayName,
        };
      }
      setRightServiceObj(queryObj || queryObj2);
    }
  }, [appProperties?.apps, appProperties?.installedApps, appProperties?.rightServiceName, rightServiceName]);

  const handleOkForSuccessAuthModal = () => {
    handleDrawerOpen();
  };

  const handleDrawerOpen = () => {
    getAddTemplateUrl(appProperties, null).then((url) => {
      url += "&ttype=wp";
      window.open(url, "_blank");
    });
  };

  const handleCancelForSuccessAuthModal = () => {
    setShowFinishButton(true);
    setSuccessAuthModal(false);
  };

  var redirectPage = appProperties.domain + "/persons/list";
  if (appProperties?.controller?.redirectPage) {
    redirectPage = appProperties?.controller?.redirectPage;
  }

  const handleMenuClick = (e) => {
    if (e.target.value === "unipile_whatsapp") {
      navigate("/channels/personal_whatsapp" + location.search, { replace: true });
    } else {
      navigate("/channels/" + e.target.value + location.search, { replace: true });
    }
  };

  useEffect(() => {
    const phoneData = appProperties?.savedNumbers;
    const integId = rightServiceObj?.integId;

    if (!phoneData?.length || campaignStatus || !integId) return;

    const hasValidPhone = phoneData.some(
      (obj) =>
        obj?.integId === integId && obj?.isHelloSendPhoneNumber === "true" && obj?.phoneUniqueId && !obj?.phoneUniqueId?.startsWith("teams_")
    );

    if (hasValidPhone) {
      fetchData(`hellosend/account/${integId}/campaign/registration?type=PROFILE`, "POST", null, appProperties).then((response) => {
        if (!response) return;

        const parsedResponse = JSON.parse(response);
        const steps = parsedResponse?.data?.steps;

        setBrandStatus(steps?.[2]?.brand?.status);
        setCampaignStatus(steps?.[4]?.campaign?.campaignStatus || "NOT_VERIFIED");
      });
    }
  }, [appProperties?.savedNumbers, campaignStatus, fetchData, rightServiceObj?.integId]);

  const onAuthorizationSuccess = useCallback(() => {
    if (rightServiceObj?.rightServiceName === "unipile_whatsapp") {
      setShowGotoLeftService(true);
    }
  }, [rightServiceObj?.rightServiceName]);

  return (
    <>
      <InfoModal
        title={appProperties?.providerCommonObj?.successAuthModal?.title}
        content={appProperties?.providerCommonObj?.successAuthModal?.content}
        type="success"
        open={successAuthModal}
        handleOk={handleOkForSuccessAuthModal}
        handleCancel={handleCancelForSuccessAuthModal}
        okButtonText={appProperties?.providerCommonObj?.successAuthModal?.button?.ok?.text}
        cancelButtonText={appProperties?.providerCommonObj?.successAuthModal?.button?.cancel?.text}
      />
      {buyNumberLoading && <CommonLoadingV2 />}

      <Row className="ms-4 mt-2 pb-3" style={{ marginRight: "10px" }}>
        <Col span={18}>
          <BackToChannelsButton />
        </Col>

        {appProperties?.leftServiceDisplayName === "Zoho CRM" && rightServiceObj?.authorized && (
          <AppInstallationBanner appProperties={appProperties} />
        )}
        {rightServiceObj?.rightServiceName?.includes("whatsapp") && (
          <Col span={18} className="mt-2">
            <HRadioButton
              size={"large"}
              options={[
                { label: "WhatsApp", value: "unipile_whatsapp", dataCy: "radio-btn-whatsapp" },
                { label: "WABA", value: "whatsapp", dataCy: "radio-btn-waba" },
              ]}
              selectedValue={rightServiceName}
              onChange={handleMenuClick}
            />
          </Col>
        )}
        {campaignStatus && creditsAccessibleForMobile && campaignStatus !== "VERIFIED" && (
          <TenDLCStatus
            appProperties={appProperties}
            brandStatus={brandStatus}
            campaignStatus={campaignStatus}
            serviceName={rightServiceObj?.rightServiceName}
          />
        )}
        {appProperties.serviceInstalled ? (
          <Col span={6} className="d-flex align-items-end justify-content-end ms-auto">
            {showFinishButton &&
              rightServiceObj?.authorized &&
              (onBoardingPage ||
                (appProperties?.leftServiceDisplayName === "Teams" && rightServiceObj?.displayName === "Teams") ||
                rightServiceObj?.rightServiceName === "unipile_whatsapp") && (
                <>
                  <ImportChat
                    appProperties={appProperties}
                    showImportWhatsAppModal={showImportWhatsAppModal}
                    setShowImportWhatsAppModal={setShowImportWhatsAppModal}
                    onSkip={() => {
                      setShowImportWhatsAppModal(false);
                      urlParams.delete("onBoardingPage");
                      urlParams.delete("sideBar");
                      urlParams.delete("topBar");
                      window.location.href = `/inbox?${urlParams.toString()}`;
                    }}
                  />
                  <button
                    onClick={() => {
                      if (rightServiceObj?.rightServiceName === "unipile_whatsapp") {
                        setShowImportWhatsAppModal(true);
                      } else if (appProperties?.leftServiceDisplayName === "HelloSend") {
                        const urlParams = new URLSearchParams(window.location.search);
                        urlParams.delete("sideBar");
                        urlParams.delete("topBar");
                        urlParams.delete("fullView");
                        urlParams.delete("source");
                        urlParams.append("service", "hellosend");
                        window.location.href = `/inbox?${urlParams.toString()}`;
                      } else {
                        setShowGotoLeftService(true);
                      }
                    }}
                    className="goToServiceBtn"
                  >
                    {rightServiceObj?.displayName === "Teams" ? (
                      <span>Set up Business Verification </span>
                    ) : rightServiceObj?.rightServiceName === "unipile_whatsapp" ? (
                      <>
                        <span>Import WhatsApp Chats</span>
                      </>
                    ) : (
                      <span>Go To {appProperties?.leftServiceDisplayName}</span>
                    )}
                    <svg width="15px" height="10px" viewBox="0 0 13 10">
                      <path d="M1,5 L11,5"></path>
                      <polyline points="8 1 12 5 8 9"></polyline>
                    </svg>
                  </button>
                </>
              )}
          </Col>
        ) : null}
      </Row>
      {/* <BuyNumber open={showBuyNumber} closeDrawer={closeDrawer} /> */}
      <div className="ms-4 h-lg-85 overflow-y-hidden">
        <Row className="h-100">
          <Row className="w-100 h-100">
            <Col xxl={24} lg={24} md={24} xl={24} sm={24} xs={24} className="h-100">
              <Row justify={sideBar === "false" ? "center" : ""} align="top" className="h-100">
                <Col
                  xs={24}
                  sm={24}
                  md={10}
                  lg={10}
                  xl={10} //
                  xxl={10}
                  className=" pb-4 h-100"
                  style={{ height: "100%", borderRadius: 12, overflow: "auto" }}
                >
                  <Step1
                    serviceName={rightServiceObj?.displayName}
                    rightServiceObj={rightServiceObj}
                    setRightServiceObj={setRightServiceObj}
                    appProperties={appProperties}
                    onAuthorizationSuccess={onAuthorizationSuccess}
                  />
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={10}
                  lg={10}
                  xl={10} //
                  xxl={10}
                  className="ms-lg-3 pt-0"
                  style={{
                    height: "100%",
                    // minHeight: "88svh",
                    borderRadius: 12,
                  }}
                >
                  {!rightServiceObj?.authorized ? (
                    <ServiceNotAuthorizedPanel
                      appProperties={appProperties}
                      serviceName={rightServiceObj?.displayName}
                      rightServiceObj={rightServiceObj}
                    />
                  ) : (
                    <Step2 rightServiceObj={rightServiceObj} setRightServiceObj={setRightServiceObj} setShowFinishButton={setShowFinishButton} />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </div>
      <Modal
        header={null}
        footer={null}
        title={null}
        open={showGotoLeftService}
        centered
        closable
        className="finish-modal"
        onCancel={() => {
          setShowGotoLeftService(false);
        }}
        width={rightServiceObj?.rightServiceName === "whatsapp" ? 1050 : 700}
        destroyOnClose
        height={rightServiceObj?.displayName === "Twilio Voice" ? 567 : null}
      >
        {rightServiceObj?.displayName === "Teams" ? (
          <div>
            <iframe
              className="iframe-popup"
              src={"https://oapps.zohobookings.com/portal-embed#/customer/help"}
              frameBorder="0"
              allowFullScreen
              title="Schedule"
            ></iframe>
          </div>
        ) : rightServiceObj?.rightServiceName === "whatsapp" ? (
          <OnboardingFinishModalContent appProperties={appProperties} serviceName={rightServiceObj?.rightServiceName} />
        ) : (
          <VoiceOnboardingFinishPopup
            leftServiceName={appProperties?.leftServiceDisplayName}
            callProperties={callProperties}
            appProperties={appProperties}
            closePopup={() => {
              setShowGotoLeftService(false);
            }}
          />
        )}
      </Modal>
    </>
  );
}

const Step1 = ({ serviceName, rightServiceObj, setRightServiceObj, appProperties, onAuthorizationSuccess }) => {
  console.log("debug-1 appProperties?.rightServiceObj", rightServiceObj);
  return (
    <div className="d-grid gap-2">
      <AuthorizePage
        onAuthorizationSuccess={onAuthorizationSuccess}
        setRightServiceObj={setRightServiceObj}
        rightServiceObj={rightServiceObj}
        authorizeButtonName={appProperties?.providerCommonObj?.serviceAuthorizationButtonName || "Authorize"}
      />
    </div>
  );
};

export const BackToChannelsButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigateToChannelsPage = () => {
    navigate("/channels" + location.search);
  };

  return (
    <>
      <Row className="w-100">
        <Col>
          <div className="d-flex flex-row align-items-center cursor-pointer" onClick={navigateToChannelsPage}>
            <button className="back-to-channels-btn pe-5">Back</button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default TextSMSAuthPage;

export const AppInstallationBanner = ({ appProperties }) => {
  const pathname = useLocation().pathname;
  const domain = appProperties?.domain ? appProperties?.domain : "https://crm.zoho.com";
  const dcSuffix = domain?.match(/zoho\.(.*)/)?.[1] || "com";
  const marketPlaceDomain = `https://marketplace.zoho.${dcSuffix}`;

  const openCallAppInstallationLink = () => window.open(marketPlaceDomain + HELLOSEND_CALL_APP_INSTALLATION_URL, "_blank");

  const openMessageAppInstallationLink = () => window.open(marketPlaceDomain + HELLOSEND_MESSAGE_APP_INSTALLATION_URL, "_blank");

  const AppInstallPromptBanner = ({ title, description, installationButtonName, handleInstallationButtonClick }) => (
    <div className="hs-w-85 hs-bg-light-yellow p-2 hs-border-1px hs-border-0-25-rem">
      <div className="d-flex flex-row">
        <div className="actionIconsSprite warning-icon align-self-start" />

        <div className="d-flex flex-row justify-content-between w-100 ">
          <div className="d-flex flex-column gap-1">
            <div className="hs-fw-500 hs-fs-13">{title} (Ignore this if already installed)</div>
            {description && <div className="hs-fw-400 hs-fs-12 hs-color-dark-grey">{description}</div>}
          </div>

          <div className="d-flex align-items-center">
            <HButton onClick={handleInstallationButtonClick} size="small">
              {installationButtonName}
            </HButton>
          </div>
        </div>
      </div>
    </div>
  );

  const installationPromptBannerData = (() => {
    if (pathname.includes("voice")) {
      return {
        title: "To enable Click-to-Call inside Zoho CRM, install the HelloSend Call app.",
        description: "Ensure that any existing telephony integration is removed to avoid conflicts.",
        installationButtonName: "Enable Click-to-Call",
        handleInstallationButtonClick: openCallAppInstallationLink,
      };
    } else if (!pathname.includes("voice")) {
      return {
        title: "To enable SMS & WhatsApp Messaging inside Zoho CRM, install the HelloSend Messaging app.",
        description: null,
        installationButtonName: "Enable Messaging",
        handleInstallationButtonClick: openMessageAppInstallationLink,
      };
    }
    return null;
  })();

  return installationPromptBannerData ? <AppInstallPromptBanner {...installationPromptBannerData} /> : null;
};
